module.exports = __webpack_public_path__ + "images/backgrounds/hcp-page.png";